import { useState } from "react";

type Props = {
  gamePrompt: string;
  isRunning: boolean;
  onSave: (prompt: string) => void;
};

export function GamePromptEditor({ gamePrompt, isRunning, onSave }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [draft, setDraft] = useState(gamePrompt);
  const [dirty, setDirty] = useState(false);

  // Sync draft when external gamePrompt changes (e.g. loaded from server)
  const [lastExternal, setLastExternal] = useState(gamePrompt);
  if (gamePrompt !== lastExternal) {
    setLastExternal(gamePrompt);
    if (!dirty) {
      setDraft(gamePrompt);
    }
  }

  function handleSave() {
    onSave(draft);
    setDirty(false);
  }

  function handleReset() {
    setDraft(gamePrompt);
    setDirty(false);
  }

  return (
    <div className="nes-panel">
      <div className="nes-panel-header">GAME PROMPT</div>
      <div className="p-3">
        <div className="flex items-center justify-between mb-2">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="nes-btn text-xs flex-1"
          >
            {isOpen ? "▼ COLLAPSE" : "▶ EDIT GAME PROMPT"}
          </button>
        </div>

        {isOpen && (
          <>
            <textarea
              value={draft}
              onChange={(e) => {
                setDraft(e.target.value);
                setDirty(true);
              }}
              disabled={isRunning}
              className="w-full bg-black text-nes-white border-2 border-nes-border p-2 font-mono text-xs leading-relaxed resize-y focus:outline-none focus:border-nes-gold"
              style={{ minHeight: "200px", maxHeight: "500px" }}
              spellCheck={false}
            />
            <div className="flex gap-2 mt-2">
              <button
                onClick={handleSave}
                disabled={!dirty || isRunning}
                className="nes-btn nes-btn-green text-xs flex-1"
              >
                SAVE
              </button>
              <button
                onClick={handleReset}
                disabled={!dirty || isRunning}
                className="nes-btn text-xs flex-1"
              >
                RESET
              </button>
            </div>
            {dirty && (
              <div className="font-pixel text-xs text-nes-gold mt-1">
                Unsaved changes
              </div>
            )}
            {isRunning && (
              <div className="font-pixel text-xs text-nes-gray mt-1">
                Cannot edit while running
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
